import React, { createContext, useContext, useMemo } from "react";
import * as Option from "@utils/Option";
import type { OptionTs } from "@ps-bridge/interop";
import type { EmailValidationClient } from "@ps-bridge/clients/emailValidation";
import { createDefaultEmailValidationClient } from "@src/purescript/interop";
import { enabledFeatures, FeaturesEnum } from "@utils/enabledFeatures";
import { requireContext } from "@contexts/requireContext";

const EmailValidationClientContext = createContext<OptionTs<EmailValidationClient>>(Option.none());

export const EmailValidationClientProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const emailValidationClient = useMemo<EmailValidationClient>(() => {
    if (enabledFeatures[FeaturesEnum.StubClients]) {
      return createDefaultEmailValidationClient;
    }
    return createDefaultEmailValidationClient;
  }, []);

  const contextValue = useMemo(() => Option.some(emailValidationClient), [emailValidationClient]);

  return (
    <EmailValidationClientContext.Provider value={contextValue}>
      {children}
    </EmailValidationClientContext.Provider>
  );
};

export const useEmailValidationClient = (): EmailValidationClient => {
  return requireContext(
    useContext(EmailValidationClientContext),
    "useEmailValidationClient must be used within an EmailValidationClientProvider",
  );
};
